import jalaliToGregorian from "./jalaliToGregorianV1";

const isJalaliDate = (year) => {
  return Number(year) < 1700;
};

const normalizeDate = (dateString) => {
  if (!dateString || typeof dateString !== "string") {
    return null;
  }
  // console.log("dateString", dateString);
  const [datePart, timePart = "00:00:00"] = dateString.split("T");
  // console.log("datePart", datePart);
  // console.log("timePart", timePart);

  const [year, month, day] = datePart.split("-").map(Number);

  const [hour, minute, second] = timePart.split(":").map(Number);

  // Jalali
  if (isJalaliDate(year)) {
    // console.log("year", year);
    // console.log("month", month);
    // console.log("day", day);
    const gregorian = jalaliToGregorian(year, month, day);

    return new Date(
      gregorian.year,
      gregorian.month - 1,
      gregorian.day,
      hour || 0,
      minute || 0,
      second || 0,
    );
  }

  // Gregorian
  return new Date(year, month - 1, day, hour || 0, minute || 0, second || 0);
};

export default normalizeDate;
